<template>
  <modal
    :visible="$city.isCityModalShown"
    allow-close
    @on-close="$city.$emit('city:close')"
  >
    <city-search
      locally
      @choose="change"
    />
  </modal>
</template>

<script>
import citySearch from '../header/city-search.vue';

export default {
  components: {
    citySearch,
  },

  methods: {
    change(city) {
      this.$city.$emit('city', city);
    }
  },
}
</script>
